import api from 'helpers/api';
import { normalizeSegment, TWireSegment } from 'helpers/audience';
import API_ENDPOINT from 'constants/apiEndpoint';
import { TApiResult } from 'types/common';
import { TCreateSegmentBody, TSegment } from 'types/segment';

export const getSegments = (): Promise<TSegment[]> =>
  api
    .get<TApiResult<TWireSegment[]>>(API_ENDPOINT.audience.segments)
    .then((r) => (r.result ?? []).map(normalizeSegment));

export const getSegment = (id: string): Promise<TSegment> =>
  api
    .get<TApiResult<TWireSegment>>(API_ENDPOINT.audience.segment(id))
    .then((r) => normalizeSegment(r.result));

export const createSegment = (body: TCreateSegmentBody): Promise<TSegment> =>
  api
    .post<TApiResult<TWireSegment>>(API_ENDPOINT.audience.segments, body)
    .then((r) => normalizeSegment(r.result));
